"use client";

import { useState, useEffect } from "react";
import Image from "next/image";
import {useTheme} from "@/context/ThemeContext";

interface LoaderProps {
  isLoading?: boolean;
  size?: number;
  borderWidth?: number;
  logoSize?: number;
  autoHide?: boolean;
  duration?: number;
}

export default function Loader({
  isLoading = true,
  size = 60,
  borderWidth = 3,
  logoSize = 60,
  autoHide = true,
  duration = 3000,
}: LoaderProps) {
  const [loading, setLoading] = useState(isLoading);
  const [visible, setVisible] = useState(isLoading);
  const {theme} = useTheme();

  useEffect(() => {
    if (isLoading) {
      setLoading(true);
      setVisible(true);
    } else {
      const timer = setTimeout(() => {
        setVisible(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect(() => {
    if (autoHide) {
      const timer = setTimeout(() => setLoading(false), duration);
      return () => clearTimeout(timer);
    }
  }, [autoHide, duration]);

  if (!visible && !loading) return null;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-white z-50 transition-opacity duration-500 ${
        loading ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="relative">
        <div
          className="rounded-full border-t-transparent animate-spin"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            borderWidth: `${borderWidth}px`,
            borderColor: "#f3f4f6",
            borderTopColor: "transparent",
          }}
        />

        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <Image
            src={theme.faviconUrl}
            alt="Loading logo"
            width={logoSize}
            height={logoSize}
            className="animate-pulse"
          />
        </div>

      </div>
    </div>
  );
}
